import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatPipe } from 'ngx-moment';
import { map, Observable, of } from 'rxjs';
import { ItemDetails } from 'src/app/models/item-details';
import { UserIdToNamePipe } from 'src/app/shared/pipes/user-id-to-name.pipe';
import { ConfigService } from 'src/app/shared/services/config.service';

@Pipe({
  name: 'jobDescription',
  standalone: true
})
export class JobDescriptionPipe implements PipeTransform {
  private readonly dateFormat = ConfigService.dates.shortDateTimeFormat;

  constructor(
    private userIdToNamePipe: UserIdToNamePipe,
    private datePipe: DateFormatPipe,
    private titleCasePipe: TitleCasePipe
  ) {}

  transform(
    value: ItemDetails['outstandingDeliveries'][number]
  ): Observable<string> {
    const direction = value.type === 'Delivery' ? 'to' : 'from';
    if (!value.allocated_to) {
      return of(
        `${this.titleCasePipe.transform(value.type)} ${direction} ${value.location} due on ${this.datePipe.transform(value.due, this.dateFormat)} (Unassigned)`
      );
    }
    const userName$ = this.userIdToNamePipe.transform(value.allocated_to);

    return userName$.pipe(
      map((name) => {
        return `${this.titleCasePipe.transform(value.type)} ${direction} ${value.location} due on ${this.datePipe.transform(value.due, this.dateFormat)} and is assigned to ${name}`;
      })
    );
  }
}
